import { TextPromo } from 'components/ui'
import { Href } from 'components/ui/Href/Href'
import { useResize } from 'utils/hooks/useResize'

import { SupportCardType } from '../../types'

import bookImg from 'assets/img/promo-page/support-card/bookImg.webp'
import giftImg from 'assets/img/promo-page/support-card/giftImg.webp'
import walletImg from 'assets/img/promo-page/support-card/walletImg.webp'
import ArrowIcon from 'assets/img/shared/arrow2.svg?react'
import s from './SupportCard.module.scss'

const illustrations = [walletImg, giftImg, bookImg]

interface ISupportCard {
  card: SupportCardType
}

export const SupportCard = ({ card }: ISupportCard) => {
  const { isSTablet, isSDesktop } = useResize()

  return (
    <Href className={s.cardContainer} href={card.link} target={card?.linkType && '_blank'}>
      <div className={s.imgWrapper}>
        <div style={{ backgroundImage: `url(${illustrations[card.id - 1]})` }} className={s.cardImage} />
      </div>
      <TextPromo
        className={s.cardTitle}
        size={isSDesktop ? (isSTablet ? 's20' : 's28') : 's24'}
        weight="w550"
        fontFamily="ASLHaussVF"
      >
        {card.title}
        <ArrowIcon />
      </TextPromo>
    </Href>
  )
}
